<template>
  <input
    class="bg-gray-100 text-gray-800 w-full rounded-md font-semibold px-6 py-4 border-2 border-gray-100"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    ref="input"
  />
</template>

<style scoped>
input {
  font-size: 18px !important;
  &:focus {
    border: 2px solid white !important;
  }
}
input::placeholder {
  @apply text-gray-800;
}
</style>

<script>
export default {
  props: ['modelValue'],

  emits: ['update:modelValue'],

  methods: {
    focus() {
      this.$refs.input.focus()
    }
  }
}
</script>
